import React from 'react'

import AppTypeItem from '../Action/AppTypeItem'

import {
    AppScrollContainerDiv,
} from '../../Styles/Components/AppContainerStyles'

import { 
    useSelector,
    useDispatch
} from 'react-redux'

function AppTypeContainer(props){
    const user = useSelector(state => state.user.user)
    const userGroup = user.user_group

    const appTypes = userGroup === 'base' ? ['resume'] : ['resume']

    return (
        <AppScrollContainerDiv>
            {appTypes.map(type => (
                <AppTypeItem appType={type} key={type} />
            ))}
        </AppScrollContainerDiv>
    )
}

export default AppTypeContainer